import React from 'react';
import { Sparkles, FileCode, Layout, Server, Cloud, Shield } from 'lucide-react';
import './EntryPricing.css';

const entryPricingData = [
  {
    icon: <Cloud size={32} />,
    title: 'Cloud VPS Hosting',
    price: 'from ₹220',
    priceUnit: '/ month',
    description: 'Powered by A2z Cloud - Managed hosting with uptime guarantee',
    category: 'cloud',
    popular: true
  },
  {
    icon: <Sparkles size={32} />,
    title: 'Minimum Contract',
    price: '₹9,999',
    priceUnit: '',
    description: 'Small tasks, audits, setup, test work',
    category: 'development'
  },
  {
    icon: <Layout size={32} />,
    title: 'Landing Pages & Websites',
    price: 'from ₹12,999',
    priceUnit: '',
    description: 'Modern responsive websites with React/Next.js',
    category: 'development'
  },
  {
    icon: <FileCode size={32} />,
    title: 'White-Label Laravel Projects',
    price: 'from ₹39,999',
    priceUnit: '',
    description: 'Complete Laravel applications and custom solutions',
    category: 'development'
  },
  {
    icon: <Server size={32} />,
    title: 'Server Setup & Deployment',
    price: 'from ₹4,999',
    priceUnit: '',
    description: 'VPS configuration, deployment, optimization',
    category: 'cloud'
  },
  {
    icon: <Shield size={32} />,
    title: 'Server Care Monthly Plans',
    price: 'from ₹2,999',
    priceUnit: '/ month',
    description: 'Managed hosting, security, monitoring, backups',
    category: 'cloud'
  }
];

const EntryPricing = () => {
  return (
    <section className="entry-pricing-section" id="pricing">
      <div className="entry-pricing-container">
        <div className="entry-pricing-header">
          <h2 className="section-title">Engagement & Entry Pricing</h2>
          <p className="section-description">
            Transparent indicative pricing — final cost depends on scope
          </p>
        </div>
        
        <div className="entry-pricing-grid">
          {entryPricingData.map((item, index) => (
            <div key={index} className={`entry-pricing-card ${item.popular ? 'popular' : ''}`}>
              {item.popular && <span className="popular-badge">Popular</span>}
              <div className="entry-pricing-icon">{item.icon}</div>
              <h3 className="entry-pricing-title">{item.title}</h3>
              <div className="entry-pricing-price">
                {item.price}
                {item.priceUnit && <span className="price-unit">{item.priceUnit}</span>}
              </div>
              <p className="entry-pricing-description">{item.description}</p>
            </div>
          ))}
        </div>
        
        <div className="entry-pricing-note">
          <p><strong>Note:</strong> Final pricing depends on scope. Start with hosting or small projects, then scale into full white-label partnerships and monthly retainers.</p>
        </div>
      </div>
    </section>
  );
};

export default EntryPricing;